module.exports = __webpack_public_path__ + "static/media/rovan shot 02.e26c7b9d.webp";